<template>
  <div class="directorWrap">
    <el-dialog
      class="dialogWrap"
      :title="isAdd ? $t('enroll.establish.addEPApplicant') : $t('enroll.establish.editEPApplicant')"
      :visible.sync="visible"
      :close-on-click-modal="false"
      center
      append-to-body
      width="1100px"
      top="5vh"
    >
      <!-- 拷贝 股东/董事信息 -->
      <div>
        <el-dropdown trigger="click" placement="bottom-start" :disabled="isReadonly" @command="commandHandle">
          <span class="crp el-dropdown-link">
            {{ $t("enroll.questionnaire.copyShareholderOrDirectors") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-if="copyFromList.length != 0">
              <el-dropdown-item v-for="item of copyFromList" :key="item.id" :command="item">
                [{{ $t("enroll.questionnaire.personalForm") }}] {{ item.fullName }} / {{ item.email }}
              </el-dropdown-item>
            </template>
            <template v-else>
              <!-- 无数据 -->
              <el-dropdown-item disabled>{{ $t("common.placeholder.noData") }}</el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
        <p class="fs12 lh16 crgy919">
          {{ $t("enroll.questionnaire.copyShareholderOrDirectorsHint") }}
        </p>
      </div>

      <!-- EP签证信息 - 表单面板 -->
      <ep-visa-form-panel ref="epVisaPanel" :form="dataForm" :isReadonly="isReadonly"></ep-visa-form-panel>

      <div class="pt20 wdb100 fxRow" v-if="!isReadonly">
        <el-button type="primary" @click="onSubmit" class="pl20 pr20">{{ $t("common.button.affirm") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EpVisaFormPanel from "./EpVisaFormPanel.vue";
import { createDataForm, normalizeEpVisaForm } from "./formFactory";
import { mapState } from "vuex";

export default {
  name: "EpVisaAddOrUpdate",
  components: { EpVisaFormPanel },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      dataForm: createDataForm(),
      copyFromList: [],
      isAdd: true,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
  },
  methods: {
    // 设置拷贝股东/董事信息列表
    setCopyFromList() {
      const applymentDetail = JSON.parse(JSON.stringify(this.applymentDetail));
      const companyMemberList = applymentDetail.companyMemberList || [];
      this.copyFromList = companyMemberList.filter(item => item.memberType == "INDIVIDUAL");
    },
    // 拷贝自
    commandHandle(item) {
      // 保留之前EP申请人上传的文件，避免覆盖
      const applicantPersonalInfoUrls = this.dataForm.applicantPersonalInfoUrls || [];

      this.dataForm = {
        ...createDataForm(),
        fullName: item.fullName,
        nationality: item.nationality,
        identificationType: item.identificationType,
        identificationNo: item.identificationNo,
        email: item.email,
        phone: item.phone || "",
        residentialAddress: item.residentialAddress,
        birthDate: item.birthDate,
        isHoldShareOfPrcInland: item.isHoldShareOfPrcInland,
        holdShareOfPrcEntity: item.holdShareOfPrcEntity,
        applicantPersonalInfoUrls,
      };
    },
    // 初始化
    init(data) {
      if (data) {
        this.isAdd = false;
        this.dataForm = normalizeEpVisaForm(JSON.parse(JSON.stringify(data)));
      } else {
        this.isAdd = true;
        this.dataForm = createDataForm();
      }

      this.$nextTick(() => {
        if (this.$refs.epVisaPanel) this.$refs.epVisaPanel.clearValidate();
      });
      // 设置拷贝股东/董事信息列表
      this.setCopyFromList();
      // 为空的号码设置默认区号 65(新加坡)
      if (!this.dataForm.phone) this.dataForm.phone = "65-";
      // 显示
      this.visible = true;
    },
    // 确认(由面板触发校验)
    onSubmit() {
      const panelRef = this.$refs.epVisaPanel;
      panelRef.validate(valid => {
        if (!valid) return;
        const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
        this.$emit("update", dataFormCopy);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogWrap ::v-deep {
  .el-dialog__header {
    padding: 15px 20px;
    font-weight: bold;
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 15px;
    font-size: 20px;
  }
}
</style>
